import { DEFAULT_TONE } from 'features/ai-generators/constants';

import { useBaseGeneratorForm } from '../../BaseAIGeneratorDrawer/hooks/useBaseGeneratorForm';

export const usePresentationMakerGeneratorForm = ({
  defaultPresentationContent,
  footerExtraButtons,
  isAutoRetrievalEnabled,
  onClickGenerate,
  onClickRateButton,
  autoGenerationConfig = {}
}) => {
  const config = {
    enabled: isAutoRetrievalEnabled,
    defaultContent: defaultPresentationContent,
    condition: autoGenerationConfig.condition,
    ...autoGenerationConfig
  };

  return useBaseGeneratorForm({
    defaultTone: DEFAULT_TONE,
    footerExtraButtons,
    onClickGenerate,
    onClickRateButton,
    autoGenerationConfig: config
  });
};
